import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';

const saveCcDisabled: PaymentProvider[] = [
  PaymentProvider.Square,
  PaymentProvider.TwoCheckout,
  PaymentProvider.StripeGateway,
];

export const isSaveCcDisabled = (providerId: PaymentProvider): boolean => saveCcDisabled.includes(providerId);
